module.exports = __webpack_public_path__ + "static/cleanup-dfce2875ae0cd6ce57b5dfb58c71a4b7.webp";